import { useTranslation } from '@crehana/i18n';

import { ADD_USERS_COURSE_PAGE_KEY } from '../constants';
import locales from '../i18n';
import type { TKeys } from '../i18n/types';

const useAssignUserTranslation = () => {
  const translations = useTranslation<TKeys>(ADD_USERS_COURSE_PAGE_KEY);

  translations.addResourceBundle(locales);

  return translations;
};

export default useAssignUserTranslation;
